import { useCallback, useEffect, useRef, useState } from 'react';

export function useAdminResource<T>(load: () => Promise<T>) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const version = useRef(0);
  const refresh = useCallback(async () => {
    const current = ++version.current;
    setLoading(true); setError(false);
    try { const result = await load(); if (version.current === current) setData(result); }
    catch { if (version.current === current) setError(true); }
    finally { if (version.current === current) setLoading(false); }
  }, [load]);
  useEffect(() => { setData(null); void refresh(); return () => { version.current++; }; }, [refresh]);
  return { data, loading, error, refresh };
}
